import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  flag: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Sophie Mercier',
  role: 'Professeure de Vinyasa Flow',
  location: 'Paris, France',
  flag: '🇫🇷',
  quote: "J'ai acheté le pack un dimanche soir. Le lundi, j'étais en cours avec une séquence parfaitement planifiée. Les cours du Volume 1 sont exactement ce dont j'avais besoin pour mes groupes débutants. Plus jamais d'improvisation.",
  initials: 'SM',
  color: '#8B6FBF'
}, {
  name: 'Marc Dubois',
  role: 'Propriétaire de Studio — Hatha & Vinyasa',
  location: 'Lyon, France',
  flag: '🇫🇷',
  quote: "Le meilleur investissement de l'année. Les fiches anatomiques m'ont donné la sécurité pour travailler avec des élèves ayant des hernies et scolioses. Je ne navigue plus à vue, j'ai un plan clair et professionnel.",
  initials: 'MD',
  color: '#D4A574'
}, {
  name: 'Amélie Rousseau',
  role: 'Professeure Certifiée',
  location: 'Montréal, Canada',
  flag: '🇨🇦',
  quote: "Je pensais que c'était \"encore un PDF de plus\", mais c'est un autre niveau. Les 6 volumes sont organisés par objectif et niveau — je trouve ce dont j'ai besoin instantanément. Pour 19€, c'est une aubaine.",
  initials: 'AR',
  color: '#0F8B6F'
}, {
  name: 'Camille Laurent',
  role: 'Professeure de Yoga Thérapeutique',
  location: 'Genève, Suisse',
  flag: '🇨🇭',
  quote: 'Le Guide des Variations en 3 Niveaux a éliminé le problème du groupe hétérogène. Maintenant je montre les 3 versions de chaque posture et chaque élève choisit celle qui lui correspond. Ça vaut 10 fois le prix.',
  initials: 'CL',
  color: '#D98AA8'
}, {
  name: 'Thomas Bernard',
  role: 'Professeur & Kinésithérapeute',
  location: 'Bruxelles, Belgique',
  flag: '🇧🇪',
  quote: "Les blocs pour populations spéciales sont de l'or pur. Je travaille avec des femmes enceintes et des seniors et j'ai enfin du matériel professionnel fiable. Le Script du Premier Cours a changé ma conversion.",
  initials: 'TB',
  color: '#8B6FBF'
}, {
  name: 'Julie Martin',
  role: 'Professeure Vinyasa Avancé',
  location: 'Marseille, France',
  flag: '🇫🇷',
  quote: "Je l'ai téléchargé un vendredi et le lundi je donnais déjà de nouveaux cours. Compatible avec tablette, donc je l'emmène au studio sans rien imprimer. Le taux d'abandon de mes groupes a considérablement baissé.",
  initials: 'JM',
  color: '#D4A574'
}, {
  name: 'Léa Fontaine',
  role: 'Professeure Hatha & Yin',
  location: 'Toulouse, France',
  flag: '🇫🇷',
  quote: "Le Calendrier Annuel et les Playlists curatées m'économisent des heures chaque semaine. Mes cours ont un rythme professionnel et mes élèves le remarquent. L'investissement s'est rentabilisé dès la première semaine.",
  initials: 'LF',
  color: '#0F8B6F'
}, {
  name: 'Nicolas Petit',
  role: 'Professeur Certifié',
  location: 'Bordeaux, France',
  flag: '🇫🇷',
  quote: "Après 8 ans d'enseignement, je sentais que je répétais la même chose. Le Volume III (Flow Dynamique) m'a apporté de la fraîcheur. Les élèves avancés se sentent à nouveau challengés.",
  initials: 'NP',
  color: '#D98AA8'
}, {
  name: 'Emma Moreau',
  role: 'Professeure de Yoga Prénatal',
  location: 'Nice, France',
  flag: '🇫🇷',
  quote: 'Les protocoles pour élèves avec hernies et ostéoporose sont précis : quoi faire, quoi ne pas faire, quoi dire. Maintenant je travaille sereinement et mes élèves me font davantage confiance.',
  initials: 'EM',
  color: '#8B6FBF'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-297">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-298"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-299">
        <div className="text-center mb-10 sm:mb-14" data-id="element-300">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-301">
            ⭐ Témoignages Réels
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-302">
            Des professeurs de toute la{' '}
            <span className="text-primary" data-id="element-303">francophonie</span> l'utilisent déjà.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4 flex-wrap" data-id="element-304">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-305">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-306">
              4.9/5 · +800 avis vérifiés dans 9+ pays
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-307">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-308">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-309">
                "
              </span>

              <div className="flex items-center gap-2 mb-3" data-id="element-310">
                <span className="text-[#E0A52E] text-sm" data-id="element-311">⭐⭐⭐⭐⭐</span>
                <span className="text-xl" aria-hidden="true" data-id="element-312">
                  {t.flag}
                </span>
              </div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-313">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-314">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-315">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-316">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-317">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-318">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-319">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-320">
          Plus de{' '}
          <span className="text-primary font-bold" data-id="element-321">15.000 professeurs</span>{' '}
          dans toute la francophonie enseignent déjà avec YOGA CLÉ EN MAIN™.
        </p>
      </div>
    </section>;
}